import React, { useEffect, useRef } from 'react';
import './FullWidthCarousel.css';

const FullWidthCarousel = ({ images }) => {
  const carouselRef = useRef(null);
  const ITEM_WIDTH = 200;

  // Дублируем изображения для бесконечной прокрутки
  const extendedImages = [...images, ...images, ...images];

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -ITEM_WIDTH, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: ITEM_WIDTH, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const carousel = carouselRef.current;
    const totalWidth = ITEM_WIDTH * images.length;

    // Изначально прокручиваем к началу "реальных" слайдов
    if (carousel) {
      carousel.scrollLeft = totalWidth;
    }

    const handleScroll = () => {
      if (!carousel) return;

      if (carousel.scrollLeft <= 0) {
        // Прокручиваем к "реальному" концу
        carousel.scrollLeft = totalWidth;
      } else if (carousel.scrollLeft >= totalWidth * 2) {
        // Прокручиваем к "реальному" началу
        carousel.scrollLeft = totalWidth;
      }
    };

    carousel.addEventListener('scroll', handleScroll);
    return () => carousel.removeEventListener('scroll', handleScroll);
  }, [images]);

  return (
    <div className="carousel-wrapper">
      <button className="carousel-button left" onClick={scrollLeft}>
        &#9664;
      </button>
      <div className="carousel-container" ref={carouselRef}>
        <div className="carousel-track">
          {extendedImages.map((image, index) => (
            <a href={image.link} className="carousel-item" key={index}>
              <img src={image.src} alt={`Slide ${index + 1}`} loading="lazy" />
            </a>
          ))}
        </div>
      </div>
      <button className="carousel-button right" onClick={scrollRight}>
        &#9654;
      </button>
    </div>
  );
};

export default FullWidthCarousel;
